module.exports = "<div class=\"form-container\">\n  <button (click)=\"loginGoogle()\" class=\"google\">Login or Signup With Google</button>\n  <button routerLink=\"/email-login\" class=\"email\">Email</button>\n  <a routerLink=\"/signup\" routerLinkActive=\"active\" class=\"create-account-txt\">No account? <strong>Create one here</strong></a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.html
// module id = ./src/app/login/login.component.html
// module chunks = main